import Appointment from './_Appointment';

export default Appointment;
